import { Button, ExternalLinkSVG, Icon } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import {
  buttonCss,
  ctaContainer,
  headlineCss,
  headlineContainerCss,
  iconCss,
  curatedFormativeConnectionOption,
  curatedFormativeConnectionOptionsCss,
} from "./CuratedFormativeOption.style";

const propTypes = {
  contentId: PropTypes.string,
  cta: PropTypes.object,
  data: PropTypes.object.isRequired,
  streamName: PropTypes.object,
};

const ButtonWithTrackEvent = withTrackEvent(Button);
const CuratedFormativeOption = ({ contentId, cta, data, streamName }) => {
  if (!cta) {
    return null;
  }

  const scienceOptions = ["Drag & Drop", "Multiple Selection", "Categorize"];
  const ssOptions = ["Multiple Choice", "Multiple Selection", "Categorize"];

  const curatedConnectionOptions = {
    SCIENCE: scienceOptions,
    SOCIAL_STUDIES: ssOptions,
  };

  const eventProperties = {
    objectType: "User",
    actionName: "Navigate",
    streamProperties: {
      description: cta.headline,
      content_id: contentId,
    },
  };

  return (
    <form method="post" action={cta.url} target="_blank">
      <input name="id_token" type="hidden" value={data.payload} />
      <ButtonWithTrackEvent
        __cssFor={{ root: buttonCss, Icon: { root: iconCss } }}
        ariaProps={{
          "aria-label": `${cta.headline}. Opens in new tab`,
        }}
        dataProps={{
          "data-qa-selector": "curated-formative-activity-panel-link",
        }}
        flavor={Button.flavors.muted}
        type="submit"
        {...eventProperties}
      >
        <div css={ctaContainer}>
          <div css={headlineContainerCss}>
            <div>
              <h4 css={headlineCss}>{cta.headline}</h4>
              {cta.body && (
                <span css={headlineCss}>
                  by <strong>Newsela Staff</strong>
                </span>
              )}
            </div>
            <Icon
              __cssFor={{ root: iconCss }}
              SvgComponent={ExternalLinkSVG}
              size={Icon.sizes.sm}
            />
          </div>
          {curatedConnectionOptions?.[streamName]?.length > 0 && (
            <div style={curatedFormativeConnectionOptionsCss}>
              {curatedConnectionOptions[streamName].map((option, index) => (
                <div style={curatedFormativeConnectionOption} key={index}>
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </ButtonWithTrackEvent>
    </form>
  );
};

CuratedFormativeOption.propTypes = propTypes;

export default CuratedFormativeOption;
